//
// Copyright (c) 2011-2017 by Curalate, Inc.
//

import angular from 'angular';

angular.module('curalate').filter('meds', ['SessionVarsService', (SessionVarsService) => {
  return (fileId: string, params: string) => {
    const medsBase = SessionVarsService.getBaseUrl('meds');
    const medsParams = params ? `/${params}` : '';

    return `${medsBase}/v1/img/${fileId}${medsParams}`;
  };
},
]);
